import styled from '@emotion/styled';

import { font } from '../Font/Font.styles';

export const StyledForm = styled.form`
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-16);
  text-align: left;
`;

export const Error = styled.p`
  ${font('body-sm')};
  color: var(--color-status-error-dark);
  margin-top: var(--spacing-8);
`;
